import { filterDataMapCollection } from "../../common/service/resources/data-map/dataMapTransformers";
import { DataMapDto } from "../../common/service/server/dto/datamap/DataMapDto";
import { UUIDString } from "../../common/service/server/Types";
import { SurveyQuestionProps } from "../components/get-compliant/survey/SurveyQuestion";
import { SurveyDefinition } from "./survey";

export const UNCOMMON_QUESTION_SLUG = "uncommon-collection";
export const INFERENCES_QUESTION_SLUG = "inferences";

export const consumerCollectionSurveyName = (groupId: string): string =>
  `consumer-data-collection-${groupId}`;

const uncommonCollectionQuestion = (): SurveyQuestionProps => ({
  type: "boolean",
  slug: UNCOMMON_QUESTION_SLUG,
  disabledReason: "Uncommon collection categories are selected.",
  question:
    "Does your business collect any uncommon personal information, like physical characteristics (height, weight, eye color), or employer name?",
  helpText:
    "If you’re unsure, it’s better to select “No” for now until you’re able to confirm the answer. You can update your selection at any time.",
  visible: true,
});

export const inferencesQuestion = (): SurveyQuestionProps => ({
  type: "boolean",
  slug: INFERENCES_QUESTION_SLUG,
  question:
    "Does your business make inferences about consumers based on any of the data it collects? Inferences include information, data, assumptions, or conclusions drawn from any other personal information to create a profile about a consumer reflecting their preferences, characteristics, predispositions, behavior, attitudes, intelligence, abilities, or aptitudes.",
  helpText:
    "For example, if you use characteristics like age, gender, marital status, education level, geography, etc. to predict a consumer’s purchasing preferences for purposes of marketing campaigns, answer “Yes.”",
  visible: true,
});

const collectionQuestions = (): SurveyQuestionProps[] => {
  return [uncommonCollectionQuestion(), inferencesQuestion()];
};

// Returns true, false, or reason for true
const collectionDisabled = (
  _answers: Record<string, string>,
  anyUncommonCollected: boolean,
): Record<string, boolean | string> => {
  return {
    [UNCOMMON_QUESTION_SLUG]:
      anyUncommonCollected && "You have marked some uncommon data as collected",
  };
};

export const consumerCollectionSurvey = (
  answers: Record<string, string>,
  dataMap: DataMapDto,
  collectionGroupId: UUIDString,
): SurveyDefinition => {
  const anyUncommonCollected =
    filterDataMapCollection(dataMap, { collectionGroupId, surveyClassification: "UNCOMMON" })
      .length > 0;
  return {
    questions: collectionQuestions(),
    visibility: {},
    disabled: collectionDisabled(answers, anyUncommonCollected),
  };
};
